<template>
  <!--    修改子集群信息/设置初始化脚本/修改超线程设置/ 修改计费方式      -->
  <div>
    <div class="base-margin__left-20">
      <p>{{ $t('customCluster.activity.editCustomDetailActivity.operation') }}</p>
      <p class="base-margin__bottom-5 base-margin__left-20">
        {{ filterActivity(detailsDataInfo) }}
      </p>
      <div v-if="detailsDataInfo.activityStatus !== SubclusterActivityStatusRunning">
        <p>{{ $t('customCluster.activity.editCustomDetailActivity.result') }}</p>
        <div class="base-margin__left-20">
          <p v-if="detailsDataInfo.errorMessage === ''" class="base-margin__bottom-5">
            {{
              $t('customCluster.activity.editCustomDetailActivity.success', {action: filterActivity(detailsDataInfo)})
            }}
          </p>
          <p v-else class="base-margin__bottom-5 base-color__red">
            {{
              $t('customCluster.activity.editCustomDetailActivity.failed', {action: filterActivity(detailsDataInfo)})
            }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="detailsDataInfo.errorMessage" class="base-margin__left-20">
      <p class="base-margin__bottom-5 base-color__red base-margin__left-20">
        {{
          $t('customCluster.activity.editCustomDetailActivity.reason', {
            action: filterActivity(detailsDataInfo),
            errorMessage: detailsDataInfo.errorMessage
          })
        }}
      </p>
    </div>
  </div>
</template>
<script>
import {
  SubclusterActivityStatusRunning,
  SubclusterActivityTypeModifyInstancesChargeType,
  SubclusterActivityTypeModifySubcluster,
  SubclusterActivityTypeSetInstanceUserdata,
  SubclusterActivityTypeSetTopology
} from "@/common/constants";

export default {
  name: 'editCustomDetail',
  props: {
    detailsData: Object,
  },
  data() {
    return {
      detailsDataInfo: {},
      SubclusterActivityStatusRunning
    };
  },

  mounted() {
    this.detailsDataInfo = {...this.detailsData};
  },

  methods: {
    filterActivity(activityInfo) {
      switch (activityInfo.activityType) {
        case SubclusterActivityTypeModifySubcluster:
          return this.$t('customCluster.activity.editCustomDetailActivity.modifySubcluster');
        case SubclusterActivityTypeSetInstanceUserdata:
          return this.$t('customCluster.activity.editCustomDetailActivity.setUserdata');
        case SubclusterActivityTypeSetTopology:
          return this.$t('customCluster.activity.editCustomDetailActivity.setTopology');
        case SubclusterActivityTypeModifyInstancesChargeType:
          // eslint-disable-next-line no-case-declarations
          const event = JSON.parse(activityInfo.event);
          // eslint-disable-next-line no-case-declarations
          const list = activityInfo.detailData.map(item => item.instanceId);
          if (event.instanceChargeType === 'PREPAID') {
            return this.$t('customCluster.activity.editCustomDetailActivity.modifyToPrepaid', {
              list: list,
              period: event.period
            });
          } else {
            return this.$t('customCluster.activity.editCustomDetailActivity.modifyToPostpaid', {list: list});
          }
        default:
          return '';
      }
    },
  },
};
</script>
